import {ServiceProviderRepository} from '../repository/ServiceProviderRepository';

export class DeleteServiceProviderUseCase {
  constructor (private serviceProviderRepository: ServiceProviderRepository) {}

  async execute (id: string): Promise<void> {
    return await this.serviceProviderRepository.delete(id);
  }
}
